import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { OrgMappingLookup } from 'src/app/client-api.service';
import { PanelSize } from 'src/app/shared/tcc-ui/simple-panel/models';
import { MaintenanceService } from '../../services/maintenance.service';
import { OrgMappingLookupService } from '../services/org-mapping-lookup.service';

@Component({
  selector: 'app-org-mapping-lookup-upsert',
  templateUrl: './org-mapping-lookup-upsert.component.html',
  styleUrls: ['./org-mapping-lookup-upsert.component.scss']
})
export class OrgMappingLookupUpsertComponent implements OnInit {

  addOrEdit: 'add' | 'edit';
  currentId = 0;
  currentOrgMappingLookup: OrgMappingLookup | undefined;
  orgMappingLookupFormGroup = new FormGroup({
    id: new FormControl(0, { nonNullable: true }),
    name: new FormControl('', { nonNullable: true, validators: Validators.required }),
    meta: new FormControl('', { nonNullable: true })
  });
  panalSize: PanelSize = 'large';
  state: 'initializing' | 'loading' | 'ready' | 'saving';

  constructor(private orgMappingLookupService: OrgMappingLookupService,
              private maintenanceService: MaintenanceService,
              private activatedRoute: ActivatedRoute,
              private router: Router) {
    this.addOrEdit = 'edit';
    this.state = 'initializing';
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(routeParam => {
      this.currentId = routeParam['id'];
      if(routeParam['id'] !== '0') {
        this.addOrEdit = 'edit';
        this.getOrgMappingLookup(this.currentId);
      }
      else {
        this.addOrEdit = 'add';
        this.state = 'ready';
        this.orgMappingLookupFormGroup.reset({
          id: 0,
          name: '',
          meta: ''
        });
      }
    });
  }

  close() {
    this.maintenanceService.setMaintenanceComponenetPanelSize('large');
    this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent });
  }

  getOrgMappingLookup(id: number) {
    this.state = 'loading';
    this.orgMappingLookupService.getOrgMappingLookup(id)
      .subscribe(
        res => {
          this.currentOrgMappingLookup = res;
          this.orgMappingLookupFormGroup.patchValue({
            id: res.id,
            name: res.name ?? '',
            meta: res.meta ?? ''
          });
          this.state = 'ready';
        },
        err => {
          this.state = 'ready';
          alert('Error getting OrgMappingLookup from database!');
        });
  }

  isChanged(field: string) {
    return this.orgMappingLookupFormGroup.get(field)?.dirty;
  }

  onSubmit() {
    this.state = 'saving';
    const formValue = this.orgMappingLookupFormGroup.getRawValue();
    const orgMappingLookup: OrgMappingLookup = {
      id: this.addOrEdit === 'add' ? 0 : formValue.id,
      name: formValue.name,
      meta: formValue.meta
    };

    this.orgMappingLookupService.putOrgMappingLookup(orgMappingLookup)
      .subscribe(
        res => {
          this.orgMappingLookupService.setOrgMappingLookups();
          this.close();
        },
        err => {
          this.state = 'ready';
          alert('Error saving OrgMappingLookup!');
        });
  }
}
